<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Knowledge Resource Centre</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Library Menu</span>
          <h2>FMCET Central Library</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">Library Services</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/about/about10.jpg"
                  alt="FMCET Central Library"
                />
              </div>

              <div class="section-copy">
                <h3>Welcome to FMCET Central Library</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>

                <ul class="feature-list">
                  <li *ngFor="let item of aboutHighlights">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </section>
          </ng-container>

          <!-- Pictography -->
  <ng-container *ngSwitchCase="'tab2'">
  <section class="content-card">
    <div class="section-head">
      <h3>Pictography as on 23/03/2026</h3>
      <p>
        Department-wise availability of titles, volumes, journals, and e-resources in the central library.
      </p>
    </div>

    <div class="table-wrap library-table-wrap">
      <table class="info-table library-table">
        <colgroup>
          <col style="width: 70px" />
          <col style="width: 420px" />
          <col style="width: 95px" />
          <col style="width: 95px" />
          <col style="width: 95px" />
          <col style="width: 110px" />
          <col style="width: 180px" />
        </colgroup>

        <thead>
          <tr class="group-row">
            <th rowspan="2">Sl. No.</th>
            <th rowspan="2">Departments</th>
            <th colspan="2">Books</th>
            <th colspan="2">Journals</th>
            <th rowspan="2">E-Resources</th>
          </tr>
          <tr class="sub-row">
            <th>Titles</th>
            <th>Volumes</th>
            <th>National</th>
            <th>International</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of libraryCollection">
            <td>{{ item.sno }}</td>
            <td>{{ item.department }}</td>
            <td>{{ item.titles }}</td>
            <td>{{ item.volumes }}</td>
            <td>{{ item.national }}</td>
            <td>{{ item.international }}</td>
            <td>{{ item.eResources }}</td>
          </tr>

          <tr class="total-row">
            <td colspan="2">TOTAL</td>
            <td>5915</td>
            <td>19877</td>
            <td>84</td>
            <td>84</td>
            <td>DELNET and NDLI</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

          <!-- Sections & Resources -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Periodicals</h3>
                <p>Dedicated journal and magazine support for academic updates and research awareness.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of periodicalsParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Reference Section</h3>
                <p>Specialized reference support for academics, research, and competitive examinations.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of referenceSectionParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Back Volumes</h3>
                <p>Well-maintained archived journal collections for subject-wise and year-wise reference.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of backVolumesParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Project Reports</h3>
                <p>Bound and organized project reports for future academic and research reference.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of projectReportsParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Digital Media</h3>
                <p>Non-book materials and multimedia resources for technical learning enhancement.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of digitalMediaParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>
          </ng-container>

          <!-- Book Policy -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Book Issue Policy</h3>
                <p>Membership, lending duration, renewal, and circulation rules for library users.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of bookIssuePolicyParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Book Bank Scheme</h3>
                <p>Special academic support scheme for eligible students.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of bookBankSchemeParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Book Lost</h3>
                <p>Replacement policy in case of lost library books.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of bookLostParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Renewal</h3>
                <p>Online renewal process and required details for study holiday renewals.</p>
              </div>
              <div class="section-copy">
                <p *ngFor="let paragraph of renewalParagraphs">
                  {{ paragraph }}
                </p>

                <ul class="feature-list">
                  <li *ngFor="let item of renewalDetails">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </section>
          </ng-container>

          <!-- Facilities -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Facilities</h3>
                <p>Security, reprography, OPAC, and user-oriented service support in the library.</p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of facilitiesItems">
                  {{ item }}
                </li>
              </ul>
            </section>
          </ng-container>

          <!-- Rules -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>Rules &amp; Regulations</h3>
                <p>Guidelines to ensure proper use, discipline, and protection of library resources.</p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of rules">
                  {{ item }}
                </li>
              </ul>
            </section>
          </ng-container>

          <!-- Future Plans -->
          <ng-container *ngSwitchCase="'tab7'">
            <section class="content-card">
              <div class="section-head">
                <h3>Future Plans for the Library</h3>
                <p>Upcoming developments to enhance digital access, tracking, and resource support.</p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of futurePlans">
                  {{ item }}
                </li>
              </ul>
            </section>
          </ng-container>

          <!-- Features -->
          <ng-container *ngSwitchCase="'tab8'">
            <section class="content-card" *ngFor="let section of featureSections">
              <div class="section-head">
                <h3>{{ section.title }}</h3>
                <p>Library user support and service assistance.</p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of section.points">
                  {{ item }}
                </li>
              </ul>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Library Contact</span>
        <h3>Central Library Services</h3>
        <p>
          FMCET Central Library,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:libraryfmcet@gmail.com">
          libraryfmcet&#64;gmail.com
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Library Access</span>
        <h3>Read, Research, and Grow</h3>
        <p>
          The Central Library supports academic excellence through books,
          journals, digital resources, OPAC access, and a peaceful study environment.
        </p>
        <a href="mailto:libraryfmcet@gmail.com" class="apply-button">
          Contact Library
        </a>
      </article>
    </section>
  </div>
</div>